import React from 'react'
import Layout from '../Layout'
import DashboardLayout from '../DashboardLayout'
import Reports from '../../../utils/CommonFunctionality/Reports'

const ReportsManagement = (props) => {
    return (
        <Layout props={props}>
            <DashboardLayout title="Report Management">
                <Reports />
            </DashboardLayout>
        </Layout>
    )
}

export default ReportsManagement
